import { useAppSelector } from '../..'
import { type ITermListResponse, type ITerm } from '../../../models/Term'

export const getAllTerms = (): ITermListResponse | null => useAppSelector((state) => state.terms?.terms ?? [])
export const getTerm = (): ITerm | null => useAppSelector((state) => state.terms?.term)
export const getTermLoading = (): boolean => useAppSelector((state) => state.terms?.termLoading)
export const getTermsLoading = (): boolean => useAppSelector((state) => state.terms?.loading)
export const getDeleteLoading = (): boolean => useAppSelector((state) => state.terms?.deleteLoading)
export const getCreateAndUpdateLoading = (): boolean => useAppSelector((state) => state.terms?.createAndUpdateLoading)
